import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const menuEmptyStateDefaultVariants = {}
const menuEmptyStateCompoundVariants = []

const menuEmptyStateSlotNames = [
  [
    "surface",
    "MenuEmptyState__surface"
  ],
  [
    "description",
    "MenuEmptyState__description"
  ],
  [
    "dividerWrap",
    "MenuEmptyState__dividerWrap"
  ],
  [
    "action",
    "MenuEmptyState__action"
  ]
]
const menuEmptyStateSlotFns = /* @__PURE__ */ menuEmptyStateSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, menuEmptyStateDefaultVariants, getSlotCompoundVariant(menuEmptyStateCompoundVariants, slotName))])

const menuEmptyStateFn = memo((props = {}) => {
  return Object.fromEntries(menuEmptyStateSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const menuEmptyStateVariantKeys = []
const getVariantProps = (variants) => ({ ...menuEmptyStateDefaultVariants, ...compact(variants) })

export const menuEmptyState = /* @__PURE__ */ Object.assign(menuEmptyStateFn, {
  __recipe__: false,
  __name__: 'menuEmptyState',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: menuEmptyStateVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, menuEmptyStateVariantKeys)
  },
  getVariantProps
})